<template>
    <div id="reservation-event-modal">
            <div v-if="!isEditing" class="container">
                <div class="label-container">
                    <span class="material-icons icon">calendar_month</span>
                    <span class="label">{{ $t("message.reservation") }}</span>
                </div>

                <div class="title" style="font-size: 17px">
                    {{ $t("calendar.reservationProgramTitle", { title: reservationDetail.title }) }}
                </div>
                <div class="title">{{ getDate() }}</div>
                <div class="duration-container">
                    <span class="material-icons icon">timelapse</span>
                    <span class="duration">
                        {{ $t("calendar.durationMinutesAppointments", { duration: reservationDetail.duration }) }}
                    </span>
                </div>
                <SupsisButton class="go-link" @click="goLink()">
                    <span class="material-icons icon">open_in_new</span>
                    {{ $t("calendar.goToAppointmentProgramSettings") }}
                </SupsisButton>
                <a-divider />
                <h4>{{ $t("calendar.infoPersonMakingReservation") }}</h4>
                <div class="form">
                    <div class="material-icons icon">format_list_bulleted</div>
                    <div class="right">
                        <div class="form-title">{{ $t("calendar.bookingFormTitle") }}</div>
                        <div class="items">
                            <div class="item" v-for="(formInput, i) in eventDetail.formValues" :key="i">
                                <span class="label">{{ formInput.label + ": " }}</span>
                                {{ formInput.value }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="reservation-details">
                    <h4>{{ $t("calendar.reservationDetails") }}</h4>
                    <div class="detail-item">
                        <span class="label">{{ $t("ticket.ticketFilterList.creationDate") }}:</span>
                        <span>{{ $moment(eventDetail.createdAt).format("LLLL") }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">{{ $t("wp.summary") }}:</span>
                        <span>{{ eventDetail.summary }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">{{ $t("calendar.description") }}:</span>
                        <span>{{ eventDetail.description }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">{{ $t("chatbotv2.timePeriod")}}:</span>
                        <span>{{ eventDetail.timezone }}</span>
                    </div>
                </div>
                <div class="buttons">
                    <SupsisButton @click="editReservation()" ghost>{{ $t("calendar.cancel") }}</SupsisButton>
                    <div class="delete-button-container" v-if="isDeletable()">
                        <SupsisButton danger @click="toggleDeletePopup">{{ $t("message.delete") }}</SupsisButton>
                        <div class="custom-popup" v-if="showDeletePopup">
                            <p>{{ $t("calendar.deleteReservationEventConfirm") }}</p>
                            <div class="popup-buttons">
                                <button @click="deleteEvent" class="yes-btn">{{ $t("calendar.yes") }}</button>
                                <button @click="toggleDeletePopup" class="no-btn">{{ $t("calendar.no") }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ReservationUpdateForm
                v-else
                :eventDetail="eventDetail"
                @updateCompleted="handleUpdateCompleted"
                @cancelUpdate="handleCancelUpdate"
            />
    </div>
</template>

<script>
import { mapState } from "vuex";
import { log2 } from "../../../../utils/log2";
import { CALENDAR_API } from "../../../../api/calendar";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import CONFIG from "../../../../config/config";
import moment from "moment";
import ReservationUpdateForm from "./ReservationUpdateForm.vue";

const log = log2("CalendarTest");
export default {
    name: "ReservationEventModal",
    components: {
        SupsisButton,
        ReservationUpdateForm,
    },
    props: {
        eventDetail: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            reservationDetail: {},
            isEditing: false,
            showDeletePopup: false,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        getDate() {
            return (
                moment(this.eventDetail.start).utc(this.eventDetail.timezone).format("LLLL") +
                ` - ${moment(this.eventDetail.end).format("HH:mm")}`
            );
        },
        goLink() {
            const reservationURL = `${CONFIG.CALENDAR_URL}/?reservationId=${this.eventDetail.reservationId}&siteId=${this.site._id}&userId=${this.user._id}`;
            window.open(reservationURL, "_blank");
        },
        editReservation() {
            this.isEditing = true;
        },
        toggleDeletePopup() {
            this.showDeletePopup = !this.showDeletePopup;
        },
        deleteEvent() {
            const data = {
                userId: this.user._id,
                eventId: this.eventDetail._id,
            };
            CALENDAR_API.deleteCalendarEvent(data).then((res) => {
                this.$emit("deleteEvent", this.eventDetail);
                this.showDeletePopup = false;
            });
        },
        isDeletable() {
            return this.eventDetail.userId === this.user._id;
        },
        handleUpdateCompleted({ event, updatingFields }) {
            Object.keys(updatingFields).forEach((key) => {
                this.eventDetail[key] = updatingFields[key];
            });
            this.isEditing = false;
        },
        handleCancelUpdate() {
            this.isEditing = false;
        },
    },
    async mounted() {
        console.log("this.eventDetail-->", this.eventDetail);
        await CALENDAR_API.getReservationPlan(this.eventDetail.reservationId).then((res) => {
            console.log("getReservationPlan-->", res);
            this.reservationDetail = res;
        });
    },
};
</script>

<style lang="scss" scoped>
.container {
    padding-left: 30px;

    .label-container {
        display: flex;
        align-items: center;

        .label {
            font-weight: 700;
            font-size: 20px;
            margin-left: 5px;
        }

        .icon {
        }
    }

    .title {
        font-size: 15px;
        font-weight: 500;
        margin-top: 10px;
    }

    .duration-container {
        display: flex;
        align-items: center;
        margin-left: -30px;

        .icon {
            font-size: 20px;
            margin-right: 10px;
        }

        .duration {
        }
    }

    g.go-link {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-top: 10px;
        padding: 5px;

        .icon {
            font-size: 15px;
            margin-right: 5px;
        }
    }

    .form {
        display: flex;
        margin-left: -30px;
        margin-top: 10px;
        align-items: start;

        .icon {
            font-size: 20px;
            margin-right: 10px;
            margin-top: 15px;
        }

        .right {
            .form-title {
                font-size: 15px;
                font-weight: 500;
                margin-top: 10px;
            }

            .items {
                display: flex;
                flex-direction: column;

                .item {
                    .label {
                        font-weight: 600;
                    }
                }
            }
        }
    }

    .buttons {
        margin-top: 10px;
        display: flex;
        justify-content: end;
        gap: 10px;

        .button {
            padding: 5px 10px !important;
            cursor: pointer;
            margin-right: 5px;

            &.edit {
            }

            &.delete {
                background-color: #b5b5b5;
            }
        }
    }

    .reservation-details {
        margin-top: 20px;

        h4 {
            margin-bottom: 10px;
        }

        .detail-item {
            margin-bottom: 5px;

            .label {
                font-weight: 600;
                margin-right: 5px;
            }
        }
    }
}

.delete-button-container {
    position: relative;
    display: inline-block;

    .custom-popup {
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        background: white;
        padding: 15px;
        border-radius: 8px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        margin-bottom: 8px;
        z-index: 999999;
        width: 200px;
        text-align: center;

        &:after {
            content: '';
            position: absolute;
            bottom: -8px;
            left: 50%;
            transform: translateX(-50%);
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-top: 8px solid white;
        }

        p {
            margin: 0 0 12px 0;
            color: #333;
            font-size: 14px;
        }

        .popup-buttons {
            display: flex;
            justify-content: center;
            gap: 8px;

            button {
                padding: 5px 15px;
                border: none;
                border-radius: 4px;
                cursor: pointer;
                font-size: 14px;
                transition: all 0.3s;

                &.yes-btn {
                    background-color: #ff4d4f;
                    color: white;

                    &:hover {
                        background-color: #ff7875;
                    }
                }

                &.no-btn {
                    background-color: #f0f0f0;
                    color: #333;

                    &:hover {
                        background-color: #d9d9d9;
                    }
                }
            }
        }
    }
}
</style>
